import {SET_CHAT_IS_OPEN} from '../types';

function actionSetChatIsOpen()
{
    return {
        type: SET_CHAT_IS_OPEN
    };
}

export default actionSetChatIsOpen;


// WEBPACK FOOTER //
// ./redux/actions/chat/actionSetChatIsOpen.js